export default "__VITE_ASSET__CGPUM5OO__"